import { useEffect, useState } from 'react'
import { Box, Flex } from '@chakra-ui/react'

import DesignCard from './design-card'

import type { Design } from '@/api/designs'

interface MasonryGridProps {
  designs: Design[]
  onImageClick: (design: Design) => void
  onToggleFavorite: (designId: string, isFavorite: boolean) => void
}

function useColumnCount() {
  const [columns, setColumns] = useState(3)

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 768) setColumns(2)
      else if (window.innerWidth < 1280) setColumns(3)
      else setColumns(4)
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return columns
}

export default function MasonryGrid({
  designs,
  onImageClick,
  onToggleFavorite
}: MasonryGridProps) {
  const columns = useColumnCount()
  const columnArrays: Design[][] = Array.from({ length: columns }, () => [])

  designs.forEach((design, i) => {
    columnArrays[i % columns].push(design)
  })

  return (
    <Box px={{ base: '16px', md: '24px' }}>
      <Flex gap={{ base: '16px', md: '20px' }} w="100%">
        {columnArrays.map((col, colIndex) => (
          <Flex key={colIndex} flexDirection="column" gap={{ base: '16px', md: '20px' }} flex="1">
            {col.map((design, rowIndex) => (
              <DesignCard
                key={design.id}
                design={design}
                index={colIndex + rowIndex * columns}
                columnsPerRow={columns}
                layoutMode="masonry"
                onImageClick={onImageClick}
                onToggleFavorite={onToggleFavorite}
              />
            ))}
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}
